import { render, staticRenderFns } from "./addClassInfo.vue?vue&type=template&id=ab173a3a&scoped=true&"
import script from "./addClassInfo.vue?vue&type=script&lang=js&"
export * from "./addClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./addClassInfo.vue?vue&type=style&index=0&id=ab173a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab173a3a",
  null
  
)

export default component.exports